import { availableColors } from './constants';
import { requirementsScheduleStatus } from './types';

export const requirementsFillColor = (
  type: 'text' | 'bg' | 'border',
  totalNeeded: number,
  currentlyAssigned: number,
  scheduleStatus: requirementsScheduleStatus,
) => {
  const status = scheduleStatus === 'draft' ? 'draft' : 'normal';
  const colorAlias = availableColors[type][status];

  if (!colorAlias) return '';

  if (currentlyAssigned < totalNeeded) return colorAlias.warning ?? '';
  if (totalNeeded > 0 && currentlyAssigned === totalNeeded) return colorAlias.success ?? '';

  return colorAlias.neutral ?? '';
};
